import React from 'react'
import styles from './TermOfPayments.module.css'

import PropTypes from 'prop-types'

import {
  TextField,
  Button
} from '@material-ui/core'

class TermOfPaymentsForm extends React.Component {
  render() {
    return (
      <div>
        <form>
          <div className={styles.groupFields}>
            <TextField
              autoComplete="off"
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="name"
              fullWidth="true"
              label="Name"
              onChange={this.props.onchange}
              value={this.props.item.name}
            />

            <TextField
              autoComplete="off"
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="description"
              fullWidth="true"
              label="Description"
              onChange={this.props.onchange}
              value={this.props.item.description}
              id="description"
            />
          </div>
        </form>

        <div className={styles.actionButton}>
          <Button variant="outlined"
                  id="term-of-payments-submit" color="primary"
                  disabled={!this.props.item.name}
                  onClick={() => this.props.submit()}>Save</Button>
        </div>
      </div>
    )
  }
}

export default TermOfPaymentsForm

TermOfPaymentsForm.propTypes = {
  onchange: PropTypes.func,
  handleAutocomplete: PropTypes.func,
  handleSwitch: PropTypes.func,
  branches: PropTypes.array,
  departments: PropTypes.array,
  item: PropTypes.object,
  updateBranch: PropTypes.object,
  updateDepartment: PropTypes.object,
  submit: PropTypes.func
}
